// =============== plugin import ============= //
import React from 'react'

// ================== component import =========== //
import InformationPopup from '../../../../component/common/InformationPopup'

import Information from './botDetails/Information';
import ProductList from './botDetails/ProductList';
import FeatureList from './botDetails/FeatureList';
import ProductFeatureAssociation from './botDetails/ProductFeatureAssociation';

const BotDetails = (props) => {
    
    const { bot_details } = props;
    return (
        <>
            {
                Object.keys(bot_details).length > 0 &&
                bot_details.others_form_setup.length > 0 && (
                    <Information information_data={bot_details.others_form_setup} />
                )
            }
            {
                Object.keys(bot_details).length > 0 &&
                bot_details.product_setup.length > 0 && (
                    <ProductList product_data={bot_details.product_setup} />
                )
            }
            {
                Object.keys(bot_details).length > 0 &&
                bot_details.features_setup.length > 0 && (
                    <FeatureList feature_data={bot_details.features_setup} />
                )
            }
            {
                Object.keys(bot_details).length > 0 &&
                Object.keys(bot_details.product_feature_association_setup).length > 0 && (
                    <ProductFeatureAssociation 
                        product_feature_association_data={bot_details.product_feature_association_setup} 
                    />
                )
            }
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Product Feature Association Setup
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 data are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Association
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">
                                            Product: product 2, Feature: feature 2
                                        </span>
                                        <span className="badge badge-secondary me-2">
                                            Product: product 1, Feature: feature 1
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Example
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test exam
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Response Type
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Static Response
                                        </span>
                                        <div className='menu menu-sub menu-sub-dropdown w-400px w-md-400px' data-sai-menu='true'>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Final Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Initial Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Fail Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Action
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test action 2
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Follow up details
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Closing Utterance
                                        </span>
                                        <InformationPopup
                                            title= "Closing Utterance"
                                            info= "It is the product of the bot"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Association
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">
                                            Product: product 2, Feature: feature 2
                                        </span>
                                        <span className="badge badge-secondary me-2">
                                            Product: product 1, Feature: feature 1
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Example
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test exam
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Response Type
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Static Response
                                        </span>
                                        <div className='menu menu-sub menu-sub-dropdown w-400px w-md-400px' data-sai-menu='true'>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Final Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Initial Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Fail Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Action
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test action 2
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Follow up details
                                    </label>
                                    <div className="col-lg-9">
                                        <span
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Closing Utterance
                                        </span>
                                        <InformationPopup
                                            title= "Closing Utterance"
                                            info= "It is the product of the bot"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="separator separator-dashed border-dark my-10"></div>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Service List
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 service are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service Name
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test service
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service synonyms
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">feature1</span>
                                        <span className="badge badge-secondary me-2">feature2</span>
                                        <span className="badge badge-secondary me-2">feature3</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Action
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test action 2
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service Name
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test service
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service synonyms
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">feature1</span>
                                        <span className="badge badge-secondary me-2">feature2</span>
                                        <span className="badge badge-secondary me-2">feature3</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Action
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            test action 2
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Service Follow Up Details
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 service are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service follow up details
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Feedback
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Follow up value
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            This is test feedback
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service follow up details
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Opt-in
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Follow up value
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Yes
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Attribute Setup
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 attribute are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Attribute
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Test attribute
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Entities
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">feature1</span>
                                        <span className="badge badge-secondary me-2">feature2</span>
                                        <span className="badge badge-secondary me-2">feature3</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Validation type
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Optional
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Confirmation
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Yes
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Datatype
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Integer
                                        </span>
                                        <div className='menu menu-sub menu-sub-dropdown w-300px w-md-300px' data-sai-menu='true'>
                                            <div className='row p-5'>
                                                <div className='col-md-12'>
                                                    <h5>
                                                        Integer
                                                    </h5>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fs-4 fw-bold">2</div>
                                                        </div>
                                                        <div className="fw-semibold fs-6 text-gray-400">
                                                            Min integer
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fs-4 fw-bold">2</div>
                                                        </div>
                                                        <div className="fw-semibold fs-6 text-gray-400">
                                                            Max integer
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Max attempts
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            2
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Service follow up details
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Opt-in
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Follow up value
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            Yes
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Service Attribute Association
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 data are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Association
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">feature1</span>
                                        <span className="badge badge-secondary me-2">feature2</span>
                                        <span className="badge badge-secondary me-2">feature3</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Example
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            This is test example
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Response Type
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Static Response
                                        </span>
                                        <div className='menu menu-sub menu-sub-dropdown w-400px w-md-400px' data-sai-menu='true'>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Final Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Initial Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Fail Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Association
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">feature1</span>
                                        <span className="badge badge-secondary me-2">feature2</span>
                                        <span className="badge badge-secondary me-2">feature3</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Example
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            This is test example
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Response Type
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Static Response
                                        </span>
                                        <div className='menu menu-sub menu-sub-dropdown w-400px w-md-400px' data-sai-menu='true'>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Final Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Initial Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row px-6 p-3">
                                                <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                Fail Response
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <span className="fw-semibold text-gray-600 fs-6 d-block">
                                                                Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="separator separator-dashed border-dark my-10"></div>
            <div className='row mb-10'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-body p-5">
                            <div className='border border-dashed border-primary rounded p-3 mb-3 bg-light'>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        General Intent
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            This is test intent
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Example
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="fw-bold fs-6 text-gray-800">
                                            This is test example
                                        </span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Multiple response
                                    </label>
                                    <div className="col-lg-9">
                                        <span className="badge badge-secondary me-2">feature1</span>
                                        <span className="badge badge-secondary me-2">feature2</span>
                                        <span className="badge badge-secondary me-2">feature3</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-lg-3 fw-semibold text-muted">
                                        Follow up details
                                    </label>
                                    <div className="col-lg-9">
                                        <span 
                                            className="fw-bold fs-6 text-primary cursor-pointer"
                                            data-sai-menu-trigger='click'
                                            data-sai-menu-placement='bottom-end'
                                            data-sai-menu-flip='top-end'
                                        >
                                            Closing Utterance
                                        </span>
                                        <InformationPopup
                                            title= "Closing Utterance"
                                            info= "It is the product of the bot"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default BotDetails